import { render, staticRenderFns } from "./UserAccountDetailsBasicInformationNotificationPreferences.vue?vue&type=template&id=188a672a&"
import script from "./UserAccountDetailsBasicInformationNotificationPreferences.vue?vue&type=script&lang=js&"
export * from "./UserAccountDetailsBasicInformationNotificationPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports